const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const inline = (s) =>
  esc(s)
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/__(.+?)__/g, "<strong>$1</strong>")
    .replace(/`([^`]+)`/g, "<code>$1</code>")
    .replace(/\*\*/g, "")
    .replace(/(^|\s)\*(\S[^*]*?)\*(?=\s|$|[.,!?])/g, "$1$2");

export const stripStars = (s = "") => String(s).replace(/\*\*/g, "").replace(/__/g, "");

export function mdToHtml(md = "") {
  const lines = String(md).replace(/\r/g, "").split("\n");
  let html = "";
  let list = null;
  let table = [];
  const close = () => {
    if (list) html += `</${list}>`;
    list = null;
  };
  const flushTable = () => {
    if (!table.length) return;
    const rows = table.filter((r) => !/^\s*\|?\s*:?-{2,}/.test(r)).map((r) => r.replace(/^\s*\||\|\s*$/g, "").split("|").map((c) => inline(c.trim())));
    html += "<table><thead><tr>" + rows[0].map((c) => `<th>${c}</th>`).join("") + "</tr></thead><tbody>";
    rows.slice(1).forEach((r) => (html += "<tr>" + r.map((c) => `<td>${c}</td>`).join("") + "</tr>"));
    html += "</tbody></table>";
    table = [];
  };
  for (const raw of lines) {
    const line = raw.trimEnd();
    if (/^\s*\|.*\|\s*$/.test(line)) { close(); table.push(line); continue; }
    flushTable();
    const h = line.match(/^\s*#{1,6}\s+(.*)$/);
    const ul = line.match(/^\s*[-*•]\s+(.*)$/);
    const ol = line.match(/^\s*\d+[.)]\s+(.*)$/);
    const boldHead = line.match(/^\s*\*\*([^*]+)\*\*:?\s*$/);
    if (h || boldHead) { close(); html += `<${h && h[0].trim().startsWith("###") ? "h4" : "h3"}>${inline((h || boldHead)[1])}</${h && h[0].trim().startsWith("###") ? "h4" : "h3"}>`; }
    else if (ul) { if (list !== "ul") { close(); html += "<ul>"; list = "ul"; } html += `<li>${inline(ul[1])}</li>`; }
    else if (ol) { if (list !== "ol") { close(); html += `<ol start="${parseInt(line, 10) || 1}">`; list = "ol"; } html += `<li>${inline(ol[1])}</li>`; }
    else if (!line.trim()) close();
    else if (/^\s*-{3,}\s*$/.test(line)) close();
    else { close(); html += `<p>${inline(line)}</p>`; }
  }
  close();
  flushTable();
  return html;
}
